import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-story-img-slider',
  templateUrl: './story-img-slider.component.html',
  styleUrls: ['./story-img-slider.component.scss']
})
export class StoryImgSliderComponent {

  @Input() gallery;
  @Input() basicInfo;
  @Input() shadow;
  @Input() fundraiser;
  @Input() slideType;
  isMobile;
  autoSlide;

  constructor(
    public util: UtilService,
    public domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.autoSlide = this.gallery?.length > 1 ? true : false;
    if (this.util.isBrowser) {
      setTimeout(() => {
        const arrows = document.getElementsByClassName('glide__arrow');
        for (let i = 0; i < arrows.length; i++) {
          arrows[i].addEventListener('click', () => {
            this.autoSlide = false;
          });
        }
      }, 1000);
    }
  }

  addYoutubeEmbed(slide) {
    const id = this.util.getYouTubeId(slide.path);
    slide.videoSrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    slide.showVideo = true;
  }

}
